import styles from './media.module.scss';

interface Props {
  video: any;
  videoOptions?: {
    autoplay?: boolean;
    controls?: boolean;
    loop?: boolean;
    muted?: boolean;
    playsinline?: boolean;
  };
  fill?: boolean;
}

// @ts-ignore – videoOptions is part of the public Props interface but not applied; video attributes are hardcoded
export default function Video({ video, videoOptions, fill = false }: Props) {
  return (
    <div
      className={`${styles.video} ${fill ? styles.fill : styles.responsive}`}
      style={{ opacity: 1 }}
    >
      <video
        autoPlay={true}
        muted={true}
        loop={true}
        playsInline={true}
        preload="none"
        className={`${fill ? styles.fill : styles.responsive}`}
      >
        {video.desktop && (
          <source src={video.desktop.webm} type="video/webm" media="(min-width: 1024px)" />
        )}
        {video.desktop && (
          <source src={video.desktop.mp4} type="video/mp4" media="(min-width: 1024px)" />
        )}
        {video.tablet && (
          <source src={video.tablet.webm} type="video/webm" media="(min-width: 481px)" />
        )}
        {video.tablet && (
          <source src={video.tablet.mp4} type="video/mp4" media="(min-width: 481px)" />
        )}
        <source src={video.mobile.webm} type="video/webm" />
        <source src={video.mobile.mp4} type="video/mp4" />
        {/* Optional fallback */}
        Your browser does not support the video tag.
      </video>
    </div>
  );
}
